import { Box, Paragraph, Text } from '@zillow/constellation-10';

interface Props {
  displayName?: string;
  nickname?: string;
  accountLast4?: string;
}

export const SelectedPaymentMethod = ({ displayName, nickname, accountLast4 }: Props) => (
  <Box>
    <Paragraph textStyle="body-bold">Payment method</Paragraph>
    <Text>{`${nickname || displayName} ....${accountLast4}`}</Text>
  </Box>
);
